// extracted by mini-css-extract-plugin
export default {"wrapper":"ProviderService_wrapper__1Qgv2"};